import { WeekData } from '../types/booking-data';

export function subTotalInCents( weekData: WeekData|null, baseCost: number ): number {
	let total = baseCost;

	weekData?.weeks.forEach( ( week ) => {
		if ( !week.priceInEuroCents ) {
			return;
		}

		total += week.priceInEuroCents;
	} );

	return total;
}
